import ConfigCmsApi from '../configs/ConfigCmsApi';
import Cookies from 'js-cookie';

const headers = () => ({ Authorization: Cookies.get('adminToken') });
const unwrap = request => request.then(response => {
  if (!response?.data || response.data.status === false) throw new Error(response?.data?.error?.code || 'payments.unavailable');
  return response.data;
}, error => { throw new Error(error?.response?.data?.error?.code || 'payments.withdrawal_not_verified'); });

export default {
  async get(agencyId, currency, page) {
    const data = await unwrap(ConfigCmsApi.get(`/agencies/${agencyId}/payments`, { headers: headers(), params: { currency, page } }));
    if (data.agency_id !== Number(agencyId) || data.currency !== currency || !Array.isArray(data.balances)
      || !Array.isArray(data.payments) || !Array.isArray(data.journal) || !Number.isInteger(data.pagination?.total_count)) throw new Error('payments.invalid_response');
    return data;
  },
  async withdraw(agencyId, intent) {
    const data = await unwrap(ConfigCmsApi.post(`/agencies/${agencyId}/payments/top-placement-withdraw`, intent, { headers: headers() }));
    if (data.verified !== true || data.operation_key !== intent.operation_key || data.withdrawal?.agency_id !== Number(agencyId)
      || data.withdrawal?.currency !== intent.currency || data.withdrawal?.amount !== intent.amount || !data.withdrawal?.id) throw new Error('payments.withdrawal_not_verified');
    return data;
  },
};
